import { render, staticRenderFns } from "./InfoWindowTruck.vue?vue&type=template&id=9dff73f8"
import script from "./InfoWindowTruck.vue?vue&type=script&lang=js"
export * from "./InfoWindowTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports